module.exports = __webpack_public_path__ + "static/media/2-points.823fbeef.png";